module.exports = "<div class=\"social-share-container\">\r\n  <cm-share-button *ngFor=\"let button of buttons\"\r\n    class=\"share-button\"\r\n    [ngClass]=\"button.classes\"\r\n    [url]=\"url\"\r\n    [button]=\"button\"\r\n    (popUpClose)=\"onShareClose($event)\"\r\n  ></cm-share-button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/social-share/social-share.component.html
// module id = ../../../../../src/app/social-share/social-share.component.html
// module chunks = 4